// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__MUfa5","navLink":"Navbar_navLink__mmWnZ","logo":"Navbar_logo__wvaG3"};